module.exports = __webpack_public_path__ + "static/media/400400_01.c6ab81e1.png";